import { Patch } from 'immer';
import { DataChannel } from '../../common/channels/channel';

export const immerChannel = {
  updated: new DataChannel<{ patches: Patch[]; inversePatches: Patch[] }>(),
};
